import useUserStore from '@/stores/UserStore';
import {
  CheckSquare,
  Loader2,
  Send,
  SkipForward,
  Square,
  X,
} from 'lucide-react';

import { Button } from '@/components/ui/button';

const SelfServiceBulkActions = ({
  isMultiSelectMode,
  selectedCount,
  totalFollowersCount,
  currentPageFollowersCount,
  bulkLoading,
  activeFilter,
  onSelectAll,
  onBulkMarkSent,
  onBulkSkip,
  onBulkNotFound,
}) => {
  const isDemoAccount = useUserStore((state) => state.isDemoAccount);
  if (!isMultiSelectMode || isDemoAccount) return null;

  return (
    <div className='flex flex-col gap-3 border-t border-border/50 pt-3 sm:flex-row sm:items-center sm:justify-between'>
      <div className='flex items-center gap-3'>
        <Button
          variant='ghost'
          size='sm'
          onClick={onSelectAll}
          className='h-8 px-2'
          disabled={bulkLoading}
        >
          {selectedCount === currentPageFollowersCount ? (
            <CheckSquare className='mr-2 h-4 w-4' />
          ) : (
            <Square className='mr-2 h-4 w-4' />
          )}
          {selectedCount === currentPageFollowersCount
            ? 'Deselect All'
            : 'Select All'}
        </Button>
        {selectedCount > 0 && (
          <span className='text-sm text-muted-foreground'>
            {selectedCount} of {totalFollowersCount} selected
          </span>
        )}
        {selectedCount === 0 && (
          <span className='text-sm text-muted-foreground'>
            {totalFollowersCount} followers
          </span>
        )}
      </div>

      {selectedCount > 0 && (
        <div className='flex gap-2'>
          {/* Show Not Found button only if not in "not_found" filter */}
          {activeFilter !== 'not_found' && (
            <Button
              variant='outline'
              size='sm'
              onClick={onBulkNotFound}
              className='h-8 border-red-500 px-3 text-red-600 hover:border-red-600 hover:bg-red-50 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-950'
              disabled={bulkLoading}
            >
              {bulkLoading === 'not_found' ? (
                <Loader2 className='mr-1 h-4 w-4 animate-spin' />
              ) : (
                <X className='mr-1 h-4 w-4' />
              )}
              {bulkLoading === 'not_found'
                ? 'Processing...'
                : `Not Found (${selectedCount})`}
            </Button>
          )}

          {/* Show Skip button only if not in "skipped" filter */}
          {activeFilter !== 'skipped' && (
            <Button
              variant='outline'
              size='sm'
              onClick={onBulkSkip}
              className='h-8 border-yellow-500 px-3 text-yellow-600 hover:border-yellow-600 hover:bg-yellow-50 dark:border-yellow-400 dark:text-yellow-400 dark:hover:bg-yellow-950'
              disabled={bulkLoading}
            >
              {bulkLoading === 'skip' ? (
                <Loader2 className='mr-1 h-4 w-4 animate-spin' />
              ) : (
                <SkipForward className='mr-1 h-4 w-4' />
              )}
              {bulkLoading === 'skip'
                ? 'Processing...'
                : `Skip (${selectedCount})`}
            </Button>
          )}

          {/* Show Mark as Sent button only if not in "sent" filter */}
          {activeFilter !== 'sent' && (
            <Button
              size='sm'
              onClick={onBulkMarkSent}
              className='h-8 border-green-600 bg-green-600 px-3 text-white hover:bg-green-700'
              disabled={bulkLoading}
            >
              {bulkLoading === 'mark_sent' ? (
                <Loader2 className='mr-1 h-4 w-4 animate-spin' />
              ) : (
                <Send className='mr-1 h-4 w-4' />
              )}
              {bulkLoading === 'mark_sent'
                ? 'Processing...'
                : `Mark as Sent (${selectedCount})`}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default SelfServiceBulkActions;
